function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 16H2.511a2.198 2.198 0 01-2.179-2.489l.732-5.49C1.628 3.793 4.735 0 9 0c4.265 0 7.373 3.793 7.936 8.021l.732 5.49A2.198 2.198 0 0115.49 16H13a4 4 0 01-8 0zm10.45-7.78l.732 5.49a.698.698 0 01-.693.79H2.511a.698.698 0 01-.692-.79l.732-5.49c.501-3.761 3.186-6.72 6.45-6.72 3.262 0 5.947 2.959 6.449 6.72zM6.5 16a2.5 2.5 0 005 0h-5z",
  fill: "#313D53"
})));